import { render, staticRenderFns } from "./ModalRating.vue?vue&type=template&id=6c5a4de5&scoped=true&"
import script from "./ModalRating.vue?vue&type=script&lang=js&"
export * from "./ModalRating.vue?vue&type=script&lang=js&"
import style0 from "./ModalRating.vue?vue&type=style&index=0&id=6c5a4de5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5a4de5",
  null
  
)

component.options.__file = "ModalRating.vue"
export default component.exports